import React, { FC } from 'react'
import classNames from 'classnames'

import CircleLoading from '../circle-loading'

import styles from './FeedLoadingState.module.css'

const FeedLoadingState: FC<{ className?: string }> = (props) => {
	const { className } = props

	return (
		<div className={classNames({ [(props.className as any)]: !!className }, styles.root)}>
			<CircleLoading className={styles.loader} />
		</div>
	)
}

export default FeedLoadingState
